import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { integrationsEnabled } from '../../lib/integrations';
import { runAutopilotSession } from '../../services/autopilot';

// Cloud schedules continue when the browser closes. Outlook and development
// Ollama use this signed-in browser session, without opening sign-in popups.
export default function AutopilotRunner() {
  const { user } = useAuth();
  useEffect(() => {
    if (!integrationsEnabled || !user?.id) return;
    const controller = new AbortController();
    let busy = false, signature = '';
    const report = message => { if (!controller.signal.aborted) window.dispatchEvent(new CustomEvent('spcc:autopilot-session', { detail: message })); };
    const tick = async () => {
      if (busy || controller.signal.aborted || !navigator.onLine) return;
      busy = true;
      try {
        const state = await runAutopilotSession(user.id, controller.signal, report);
        const next = `${state.history?.[0]?.id || ''}:${state.last_calendar_at || ''}`;
        if (!controller.signal.aborted && next !== signature) {
          signature = next;
          window.dispatchEvent(new Event('spcc:data-changed'));
          window.dispatchEvent(new Event('spcc:autopilot-updated'));
        }
      } catch (error) { report(error.message); }
      finally { busy = false; }
    };
    tick();
    const timer = setInterval(tick, 60000);
    window.addEventListener('spcc:autopilot-changed', tick);
    window.addEventListener('online', tick);
    return () => { controller.abort(); clearInterval(timer); window.removeEventListener('spcc:autopilot-changed', tick); window.removeEventListener('online', tick); };
  }, [user?.id]);
  return null;
}
